import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useCallback } from 'react';
import Editor from '../../Editor';
import FormatBubbleMenu from '../../../menus/FormatBubbleMenu';
import FullscreenEditor from '../Fullscreen/Fullscreen';
import EverythingMenu from '../../../menus/EverythingMenu/EverythingMenu';
import cn from 'classnames';
import UniversalMobileMenu from '../../../menus/UniversalMobileMenu';
import { extConfig, extConfigFullscreen } from './config';
import PluginInsertMenu from '../../../menus/PluginInsertMenu';
import FullscreenIcon from '@wix/da-ds/pkg/Icons/24x24/FullView';
import { useTranslation } from 'react-i18next';
import Viewer from '../../../Viewer/presets/DeviationDescription';
import { isTouch } from '../../../utils/browser';
import isTextEmpty from '../../../utils/isEmpty';
import useIsMobileOrTouch from '../../../utils/useIsMobileOrTouch';
import EditorIconButton from '../../../menus/_partials/EditorIconButton';
import { useEditorContext } from '../../Context';
import s from './DeviationDescription.scss';
import presetViewerStyles from '../../../Viewer/presets/DeviationDescription/DeviationDescription.scss';
const DeviationDescriptionEditor = (props)=>{
    const shouldUseMobileLayout = useIsMobileOrTouch();
    const { t } = useTranslation('editor');
    const editor = useEditorContext();
    const focusEditor = useCallback((e)=>{
        if (e.target && e.target.getAttribute('data-wrapper') && !(editor === null || editor === void 0 ? void 0 : editor.isFocused)) {
            editor === null || editor === void 0 ? void 0 : editor.commands.focus('end');
        }
    }, [
        editor === null || editor === void 0 ? void 0 : editor.commands,
        editor === null || editor === void 0 ? void 0 : editor.isFocused
    ]);
    if (shouldUseMobileLayout) {
        return /*#__PURE__*/ React.createElement(FullscreenEditor, {
            modalProps: {
                contentClassName: s['devpage-bg'],
                heading: t('preset.deviation.fullscreen.heading')
            }
        }, (currentContent, isFullscreen, toggleFs, scrollRef)=>{
            var _currentContent_doc, _currentContent_doc1, _currentContent_doc2;
            return /*#__PURE__*/ React.createElement("div", {
                className: cn(s['wrapper'], isFullscreen && s['fullscreen'], shouldUseMobileLayout && s['mobile'])
            }, !isFullscreen && /*#__PURE__*/ React.createElement("div", {
                className: s['viewer'],
                onClick: toggleFs
            }, isTextEmpty((_currentContent_doc = currentContent === null || currentContent === void 0 ? void 0 : currentContent.doc) !== null && _currentContent_doc !== void 0 ? _currentContent_doc : props.initialContent) && /*#__PURE__*/ React.createElement("p", {
                className: s['fake-placeholder']
            }, t('preset.deviation.placeholder')), /*#__PURE__*/ React.createElement(Viewer, _object_spread({
                className: s['viewer-inner'],
                contentJson: (_currentContent_doc1 = currentContent === null || currentContent === void 0 ? void 0 : currentContent.doc) !== null && _currentContent_doc1 !== void 0 ? _currentContent_doc1 : props.initialContent
            }, props))), isFullscreen && /*#__PURE__*/ React.createElement("div", {
                className: cn(s['stuck'])
            }, /*#__PURE__*/ React.createElement(UniversalMobileMenu, null)), isFullscreen && /*#__PURE__*/ React.createElement("div", {
                className: cn(s['fixed-wrapper'])
            }, /*#__PURE__*/ React.createElement(Editor, _object_spread_props(_object_spread({}, props), {
                withinModal: true,
                presetId: "deviationDescription",
                className: s['root'],
                extensionConfig: isFullscreen ? extConfigFullscreen : extConfig,
                initialContent: (_currentContent_doc2 = currentContent === null || currentContent === void 0 ? void 0 : currentContent.doc) !== null && _currentContent_doc2 !== void 0 ? _currentContent_doc2 : props.initialContent,
                initialSelection: currentContent === null || currentContent === void 0 ? void 0 : currentContent.selection,
                scrollContainerRef: scrollRef,
                autoScrollWhenWithin: 50,
                placeholder: t('preset.deviation.placeholder')
            }), (_, scrollContainer)=>/*#__PURE__*/ React.createElement(React.Fragment, null, !isFullscreen && /*#__PURE__*/ React.createElement(FormatBubbleMenu, {
                    scrollContainerRef: scrollContainer
                })))));
        });
    }
    return /*#__PURE__*/ React.createElement(FullscreenEditor, {
        modalProps: {
            contentClassName: s['devpage-bg'],
            heading: t('preset.deviation.fullscreen.heading')
        }
    }, (currentContent, isFullscreen, toggleFs, scrollRef)=>{
        var _currentContent_doc;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, isFullscreen && /*#__PURE__*/ React.createElement("div", {
            className: cn(s['stuck'])
        }, /*#__PURE__*/ React.createElement(EverythingMenu, {
            wrapping: false
        })), /*#__PURE__*/ React.createElement("div", {
            className: cn(isFullscreen && s['fixed-wrapper']),
            "data-wrapper": "1",
            onClick: focusEditor
        }, /*#__PURE__*/ React.createElement(Editor, _object_spread_props(_object_spread({}, props), {
            withinModal: true,
            presetId: "deviationDescription",
            className: cn(s['editor'], presetViewerStyles['root'], !isFullscreen && s['in-form']),
            extensionConfig: isFullscreen ? extConfigFullscreen : extConfig,
            initialContent: (_currentContent_doc = currentContent === null || currentContent === void 0 ? void 0 : currentContent.doc) !== null && _currentContent_doc !== void 0 ? _currentContent_doc : props.initialContent,
            initialSelection: isFullscreen && !isTouch() && (currentContent === null || currentContent === void 0 ? void 0 : currentContent.selection),
            selfScrollContainer: !isFullscreen,
            scrollContainerRef: isFullscreen ? scrollRef : undefined,
            autoScrollWhenWithin: 50,
            placeholder: t('preset.deviation.placeholder')
        }), (_, scrollContainer)=>/*#__PURE__*/ React.createElement(React.Fragment, null, !isFullscreen && /*#__PURE__*/ React.createElement(FormatBubbleMenu, {
                scrollContainerRef: scrollContainer
            })))), !isFullscreen && /*#__PURE__*/ React.createElement("div", {
            className: cn(s['toolbar'])
        }, /*#__PURE__*/ React.createElement(PluginInsertMenu, null), /*#__PURE__*/ React.createElement(EditorIconButton, {
            featureId: "action:fullscreen",
            icon: FullscreenIcon,
            onClick: toggleFs,
            "aria-label": t('button.fullscreen'),
            tooltipText: t('button.fullscreen')
        })));
    });
};
DeviationDescriptionEditor.displayName = 'DeviationDescriptionEditor';
export default DeviationDescriptionEditor;

//# sourceMappingURL=DeviationDescription.js.map